import styled from "styled-components";

export const AppContainer = styled.div`
  min-height: 100vh;
  background: #f7f9fc;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;

  @supports (min-height: 100svh) {
    min-height: 100svh;
  }
`;

export const BleedBackgroundHost = styled.div`
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 0;

  @supports (height: 100svh) {
    height: 100svh;
  }
`;

export const MainContent = styled.main`
  flex: 1;
  min-width: 0;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: stretch;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
`;
